
import { Component, Inject, Vue, Watch, Prop } from 'vue-property-decorator';
import { VNode, CreateElement } from 'vue';

@Component({ name: 'CustomStyle' })
export default class CustomStyle extends Vue {
  @Prop({ default: '' })
  private value!: string;

  public render(createElement: CreateElement): VNode {
    return createElement('style', this.value);
  }
}
